import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/home'
import Index from '../view/index'   //首页
import Print from '../view/print'   //打印页面
import QueryList from '../view/queryList'
import Query from '../view/query'   //查找页面
import EncrollAbout from '../view/encrollabout'   //报名信息
import search from '../view/search'   //搜索页
import article from '../view/article'  //文章页
import list from '../view/list'     //列表页
import login from '../components/login' //登录

Vue.use(Router); 
const router = new Router( {
  routes:[ {
      path:'/', 
      redirect:'home/index'
    },  {
      path:'/home', 
      component:Home, 
      name:"Home", 
      children:[ {
          path:'/home/index', 
          component:Index, 
          name:'Index'
        },  {
          path:'/home/login', //登录
component:login, 
          name:'login'
        },  {
          path:'/home/print', 
          component:Print, 
          name:'print', 
          meta: {requiresAuth:true }
        },  {
          path:'/home/query', 
          component:Query, 
          name:'query', 
          meta: {requiresAuth:true }
        },  {
          path:'/home/encrollabout', 
          component:EncrollAbout, 
          name:'encrollabout', 
          meta: {requiresAuth:true }
        },  {
          path:'/home/queryList', 
          component:QueryList, 
          name:'queryList', 
          meta: {requiresAuth:true }
        },  {
          path:'/home/article/:cid/:aid', 
          component:article, 
          name:'article', 
          meta: {requiresAuth:false }
        },  {
          path:'/home/search/:sid', 
          component:search, 
          name:'search', 
          meta: {requiresAuth:false }
        },  {
          path:'/home/list/:cid', 
          component:list, 
          name:'list', 
          meta: {requiresAuth:false }
        }, 
      ]
    }, 
  ]
}); 
router.beforeEach((to, from, next) =>  {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (sessionStorage.getItem('INFO') == null) {
      next( {path:'/'})
    }else {
      next()
    }
  }else {
    next()// 确保一定要调用 next()
}
}); 

export default router; 


// WEBPACK FOOTER //
// ./src/router/index.js